import { createAsyncThunk } from '@reduxjs/toolkit';

import { createFan, getFans, removeFan } from '../../api/fansApi';

export const fetchFans = createAsyncThunk(
  'Fans/fetchFans',
  async (userId, thunkAPI) => {
    try {
      const response = await getFans(userId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const deleteFan = createAsyncThunk(
  'Fans/deleteFan',
  async (userId, thunkAPI) => {
    try {
      removeFan(userId);
      return userId;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const addFan = createAsyncThunk(
  'Fans/createFan',
  async (userId, thunkAPI) => {
    try {
      const response = await createFan(userId);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
